import { createModelSchema, primitive, object } from 'serializr';
import UiState from './UiState';
import AuthStore from '../containers/login/store/AuthStore';
import Person from '../models/Person';
import User from '../models/User';

// Ensure serializr has default schemas for persisted stores/models.
// mobx-persist relies on serializr.getDefaultModelSchema(store) and will crash
// if it returns null.

createModelSchema(Person, {
  id: primitive(),
  lastname: primitive(),
  firstname: primitive(),
  email: primitive()
});

createModelSchema(User, {
  // Person fields
  id: primitive(),
  lastname: primitive(),
  firstname: primitive(),
  email: primitive(),

  // User fields
  admin: primitive(),
  archived: primitive(),
  experience: primitive(),
  type: primitive()
});

createModelSchema(UiState, {
  language: primitive(),
  groupId: primitive(),
  sessionId: primitive(),
  organisationName: primitive()
});

createModelSchema(AuthStore, {
  // Only the persisted field(s)
  isImpersonator: object(User)
});
